module.exports = __webpack_public_path__ + "static/media/ic_sec_consumer_cyclical.beac7e98.svg";